<template>
  <div class="apply-page">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <h1 class="title">申请加入联盟</h1>
    </div>
    <div class="txt">
      <img src="@/assets/reject.png" alt="">
      <button class="submit-btn" @click="goNext()">重新申请</button>
    </div>
  </div>
</template>

<script>
import { normalizeMemberInfo } from '@/utils/memberStatus'

export default {
  name: 'ApplyReject',
  mounted () {
    this.memberType = normalizeMemberInfo(JSON.parse(sessionStorage.getItem('userInfo') || '{}')).memberType
  },
  data() {
    return {
      memberType: ''
    }
  },
  methods: {
    goNext(){
      if (this.memberType === 'PERSONAL') {
        this.$store.commit('SET_MEMBER_TYPE', 'personal')
        this.$router.push('/apply/second')
        return
      }
      const user = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
      user.companyApplyState = null
      sessionStorage.setItem('userInfo', JSON.stringify(user))
      this.$store.commit('SET_MEMBER_TYPE', 'enterprise')
      this.$router.push('/apply/second')
    }
  }
}
</script>

<style scoped>
.apply-page {
  background-color: #f8fafc;
  min-height: 100vh;
  padding-bottom: 80px;
  font-size: 12px;
}

/* 顶部导航 */
.top-nav {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
}
.back-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 auto;
}
.txt{
  width: 100%;
  height: 300px;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
img{
  width: 100px;
  height: 80px;
  margin-bottom: 30px;
}
.submit-btn {
  width: 140px;
  margin: 0 20px;
  background: #165DFF;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/menu/join/reject.vue